module.exports = __webpack_public_path__ + "img/comparison2.9b0a911b.png";